export const numberWithCommas = (x: string | number) => {
  if (x.toString().indexOf(",") !== -1 || x.toString().indexOf(".") !== -1) {
    return x;
  }
  const parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};
